import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=01063a0c&"
import script from "./Tour.vue?vue&type=script&lang=js&"
export * from "./Tour.vue?vue&type=script&lang=js&"
import style0 from "./Tour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tour.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour.vue
// module id = 1650
// module chunks = 1